/* unplugin-vue-components disabled */import script from "./PBButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PBButton.vue?vue&type=script&setup=true&lang=js"

import "./PBButton.vue?vue&type=style&index=0&id=32be8b47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32be8b47"]])

export default __exports__